<template>
  <v-menu bottom left>
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        class="ma-2"
        outlined
        v-bind="attrs"
        v-on="on"
        :close="selectedSucursal && selectedSucursal.uuid !== 'all'"
        @click:close="removeSucursal"
      >
        Sucursal
        <span v-if="selectedSucursal">: {{ selectedSucursal.nombre }}</span>
      </v-chip>
    </template>

    <v-card>
      <v-list dense>
        <v-list-item
          v-for="sucursal in sucursalesConTodas"
          :key="sucursal.uuid"
          @click="setSucursal(sucursal)"
        >
          <v-list-item-title>{{ sucursal.nombre }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "SucursalesVFilter",
  data() {
    return {
      selectedSucursal: null,
    };
  },
  computed: {
    ...mapState("sucursales", ["sucursales"]),
    sucursalesConTodas() {
      return [
        { id: 0, uuid: "all", nombre: "Todas las sucursales" },
        ...this.sucursales,
      ];
    },
  },
  watch: {
    "$route.query.uuid_sucursal": {
      immediate: true,
      handler(nuevoUuid) {
        if (nuevoUuid) {
          this.selectedSucursal = this.sucursalesConTodas.find(
            (s) => s.uuid === nuevoUuid
          );
        } else {
          this.selectedSucursal = this.sucursalesConTodas[0]; // "Todas las sucursales" por defecto
          this.updateQuery("uuid_sucursal", "all");
        }
      },
    },
  },
  methods: {
    ...mapActions("sucursales", ["fetch_sucursales"]),
    setSucursal(sucursal) {
      this.selectedSucursal = sucursal;
      this.updateQuery("uuid_sucursal", sucursal.uuid);
      if (sucursal.id > 0) {
        this.$emit("setSucursal", sucursal);
      }
    },
    removeSucursal() {
      this.setSucursal(this.sucursalesConTodas[0]);
    },
    updateQuery(clave, valor) {
      if (this.$route.query[clave] === valor) return;
      const query = { ...this.$route.query, [clave]: valor };
      this.$router.replace({ query });
    },
    removeQuery(clave) {
      const query = { ...this.$route.query };
      delete query[clave];
      this.$router.replace({ query });
    },
  },
  created() {
    this.fetch_sucursales();
  },
};
</script>
